import { LanguageCode, MultiLingual, defaultLanguage, languages, } from '@/models/language.model';
import { Close, Icon } from '@rsuite/icons';
import React, { useEffect, useRef, useState } from 'react';
import { Input, IconButton, InputGroup, SelectPicker, Dropdown } from 'rsuite';

interface MultilingualInputProps{
    value?: MultiLingual;
    disabled?: boolean;
    onChange: (value?: MultiLingual) => void;
}

const MultilingualInput: React.FC<MultilingualInputProps> = ({value, disabled, onChange}) => {
    const [inputValue, setInputValue] = useState('');
    const [selectedLang, setSelectedLang] = useState<LanguageCode>(defaultLanguage);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if(!value) return;

        setInputValue(value[selectedLang] ?? '');
    }, [selectedLang, value]);  


    const handleInputChange = (newValue: string) => {
        setInputValue(newValue);

        if (!newValue.trim()) {
            // Remove the language from the value if TextArea is empty
            removeLanguage(selectedLang);
        } else {
            // Add or update the value for the selected language
            onChange && onChange({ ...value, [selectedLang]: newValue });
        }
    };

    const isEmptyObject = (obj: object): boolean => {
        return Object.keys(obj).length === 0;
    };  
    const removeLanguage = (lang: LanguageCode) => {
        if(!value) return;

        const { [lang]: _, ...updatedValue } = value;
        onChange && onChange(isEmptyObject(updatedValue) ? undefined : updatedValue);

        // Reset TextArea if the removed language is the currently selected one
        if (selectedLang === lang) {
            setInputValue('');
        }
    }; 

    return (
        <InputGroup size="md">
            <InputGroup.Addon>
                <SelectPicker
                    size="xs"
                    data={languages}
                    value={selectedLang}
                    onChange={val => setSelectedLang(val as LanguageCode)}
                    searchable={false}
                    cleanable={false}
                    disabled={disabled}
                />
            </InputGroup.Addon>
            <Input
                ref={inputRef}
                className="lang-input"
                size="xs"
                value={inputValue}
                onChange={handleInputChange}
                placeholder="Enter text here..."
                disabled={disabled}
            />            
            <InputGroup.Addon>
                <Dropdown 
                    title={value && Object.entries(value).map(([key])=> key).join(", ")} 
                    placement='bottomEnd'
                    size='xs'
                    trigger={['hover']}
                    disabled={disabled}
                >
                    {value && Object.entries(value).map(([key, value], index) => (
                        <Dropdown.Item key={index}>
                            <IconButton
                                icon={<Icon as={Close} />}
                                appearance="subtle"
                                size="xs"
                                onClick={() => removeLanguage(key as LanguageCode)}
                            />
                            <span style={{ marginLeft: '8px' }}>
                                {languages.find(l => l.value == key)?.label}: {value}
                            </span>
                        </Dropdown.Item>
                    ))}

                </Dropdown>            
            </InputGroup.Addon>
        </InputGroup>     
    );
  };
  
  export default MultilingualInput;